<div id="contact-us" class="container-fluid">

    <div class="py-3 my-0 ml-0">
        <h1 class="mb-2" [attr.data-test]="'HP-title'">Nous Contacter</h1>
    </div>


    <div class="row col-12 col-md-8 px-0 mx-0">
        <div id="headerText" >
            <div id="headerInsideText">
                <p class="headerTextfirstParagraph" >Laissez vous guider pour connaître en fonction de votre demande, les moyens les plus efficaces pour nous
                joindre.</p>
                <p>Choisissez alors celui qui vous convient le mieux.</p>
            </div>
        </div>
    </div>

    <ng-container *ngIf="(tilesLevel1 | async)?.length > 0">
        <h2 class="row my-3 mx-0" [attr.data-test]="'title level1'">Quel sujet voulez-vous aborder ?</h2>

        <app-tiles [attr.data-test]="'tiles level1'" [parentRoute]="parentRoute1"
                   [tiles]="tilesLevel1 | async"></app-tiles>
    </ng-container>

    <ng-container *ngIf="(tilesLevel2 | async)?.length > 0">
        <h2 class="row my-3 mx-0" [attr.data-test]="'title level2'">Très bien. Sur quoi porte votre demande ?</h2>
        <app-tiles [attr.data-test]="'tiles level2'" [parentRoute]="parentRoute2"
                   [tiles]="tilesLevel2 | async"></app-tiles>
    </ng-container>

    <ng-container *ngIf="(tilesLevel3 | async)?.length > 0">
        <h2 class="row my-3 mx-0" [attr.data-test]="'title level3'">D'accord. Et plus précisément ?</h2>
        <app-tiles [attr.data-test]="'tiles level3'" [parentRoute]="parentRoute3"
                   [tiles]="tilesLevel3 | async"></app-tiles>
    </ng-container>

    <ng-container *ngIf="(tilesLevel4 | async)?.length > 0">
        <h2 class="row my-3 mx-0" [attr.data-test]="'title level4'">On y est presque. Vous souhaitez ?</h2>
        <app-tiles [attr.data-test]="'tiles level4'" [parentRoute]="parentRoute4"
                   [tiles]="tilesLevel4 | async"></app-tiles>
    </ng-container>

    <app-contact
            *ngIf="(contacts | async)?.length > 0"
            [contacts]="contacts | async"
            [tilesTitle]="tilesTitle"
            [segment2]="segment2.path"
    ></app-contact>
</div>
